import React from "react";
import { InsPortfolioCreationFundsRulesBasedGrid } from "./insPortfolioCreationFundRulesBasedGrid";
import { InsPortfolioCreationRulesBasedTabBase } from "./insPortfolioCreationRulesBasedTabBase";
import { useGetDatapointsFundOnlyFilters } from "components/workspaces/hooks/use-get-filter-values";
export const InsPortfolioCreationFundsRulesBasedTab = () => React.createElement(InsPortfolioCreationRulesBasedTabBase, { useFiltersHook: useGetDatapointsFundOnlyFilters, GridComponent: InsPortfolioCreationFundsRulesBasedGrid });
